import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles, numberToPrettyString } from '@cian/utils';
import { EConstructionStatus } from '../../types/newbuilding-mvk';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SideBlockHouseCard = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBlockHouseCard, _React$Component);
  var _super = _createSuper(SideBlockHouseCard);
  function SideBlockHouseCard() {
    var _this;
    _classCallCheck(this, SideBlockHouseCard);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function () {
      var _this$props = _this.props,
        onMouseEnter = _this$props.onMouseEnter,
        section = _this$props.section;
      if (onMouseEnter) {
        onMouseEnter(section);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      var onMouseLeave = _this.props.onMouseLeave;
      if (onMouseLeave) {
        onMouseLeave();
      }
    });
    return _this;
  }
  _createClass(SideBlockHouseCard, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        onSelect = _this$props2.onSelect,
        isHovered = _this$props2.isHovered,
        titlePrefix = _this$props2.titlePrefix,
        section = _this$props2.section;
      var sectionData = section.sectionData,
        offersInSaleCount = section.offersInSaleCount,
        houseInfo = section.houseInfo,
        constructionStatus = section.constructionStatus,
        id = section.id,
        deadlineData = section.deadlineData,
        house = section.house,
        flatTypeText = section.flatTypeText;
      var isDisabled = !houseInfo.length;
      var _getTipSettings = getTipSettings(constructionStatus),
        isGray = _getTipSettings.isGray,
        isYellow = _getTipSettings.isYellow,
        isGreen = _getTipSettings.isGreen;
      var titleSectionText = house.sections.length > 1 ? " \xB7 ".concat(titlePrefix, " ").concat(sectionData.number) : '';
      return /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread({
        id: "house-card-".concat(id),
        onClick: function onClick() {
          return onSelect(section);
        },
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, mergeStyles([styles['container'], isHovered && styles['container--hovered'], isDisabled && styles['container--disabled']])), {}, {
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles['heading'],
          children: [/*#__PURE__*/_jsx("div", {
            className: styles['tip_wrapper'],
            children: /*#__PURE__*/_jsx("span", _objectSpread(_objectSpread({}, mergeStyles(styles['tip'], isGreen && styles['tip--green'], isGray && styles['tip--gray'], isYellow && styles['tip--yellow'])), {}, {
              children: deadlineData.text
            }))
          }), /*#__PURE__*/_jsxs("strong", {
            className: styles['title'],
            children: [house.name, titleSectionText]
          }), /*#__PURE__*/_jsx("span", {
            className: styles['info'],
            children: offersInSaleCount ? "".concat(offersInSaleCount, " ").concat(flatTypeText, " \u0432 \u043F\u0440\u043E\u0434\u0430\u0436\u0435") : 'Квартиры проданы'
          })]
        }), /*#__PURE__*/_jsx("ul", {
          className: styles['house_info_list'],
          children: houseInfo.map(function (item) {
            return /*#__PURE__*/_jsxs("li", {
              className: styles['house_info_list_item'],
              children: [getHouseInfoItemLeftText(item.roomCount, item.minArea), /*#__PURE__*/_jsxs("div", {
                className: styles['house_info_list_item_right'],
                children: ["\u043E\u0442 ", numberToPrettyString(item.minPrice), " \u20BD"]
              })]
            }, item.roomCount);
          })
        })]
      }));
    }
  }]);
  return SideBlockHouseCard;
}(React.Component);
function getTipSettings(status) {
  var result = {
    isGray: false,
    isGreen: false,
    isYellow: false
  };
  switch (status) {
    case EConstructionStatus.Finished:
      result.isGreen = true;
      break;
    case EConstructionStatus.InProject:
      result.isGray = true;
      break;
    default:
      result.isYellow = true;
      break;
  }
  return result;
}
function getHouseInfoItemLeftText(rooms, minArea) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles['house_info_list_item_left'],
    children: [getHouseInfoRoomsTitle(rooms), " \u043E\u0442 ", minArea, " \u043C", /*#__PURE__*/_jsx("sup", {
      children: "2"
    })]
  });
}
function getHouseInfoRoomsTitle(rooms) {
  switch (rooms) {
    case 6:
      return "\u041C\u043D\u043E\u0433\u043E\u043A\u043E\u043C\u043D.";
    case 7:
      return "\u0421\u0432. \u043F\u043B\u0430\u043D.";
    case 9:
      return "\u0421\u0442\u0443\u0434\u0438\u044F";
    default:
      return "".concat(rooms, "-\u043A\u043E\u043C\u043D.");
  }
}